import { config } from "../config/config";
import { generateMPSignatureSHA512 } from "../utils/encodingUtil";
import { getSdk } from "./sdkService";
import { trackEvent } from "./analyticsService";

export async function getProfileAvatars() {
  try {
    const sdk = await getSdk();
    const avatars = await sdk.userManager.getAvatars();
    return avatars;
  } catch (error) {
    throw error;
  }
}
// export async function getProfileAvatars() {
//   return [
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/1.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/2.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/3.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/4.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/5.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/6.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/7.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/8.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/9.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/10.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/11.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/12.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/13.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/14.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/15.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/16.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/17.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/18.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/19.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/20.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/1.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/2.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/3.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/4.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/5.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/6.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/7.png",
//     "http://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/8.png"
//   ];
// }

export async function getCurrentProfile() {
  try {
    const sdk = await getSdk();
    const currentProfile = await sdk.userManager.getCurrentProfile();
    return currentProfile;
  } catch (error) {
    throw error;
  }
}

export async function updateCurrentProfileInIndexDB(profileData) {
  try {
    const sdk = await getSdk();
    const currentProfile = await sdk.userManager.updateCurrentProfile(profileData);
    return currentProfile;
  } catch (error) {
    throw error;
  }
}

export async function deleteCurrentProfileInIndexDB() {
  try {
    const sdk = await getSdk();
    await sdk.userManager.deleteCurrentProfile();
  } catch (error) {
    throw error;
  }
}

export async function updateSelectedProfileFromAllProfiles(profileData) {
  try {
    const sdk = await getSdk();
    const allProfiles = await sdk.userManager.updateSelectedProfileFromAllProfiles(profileData);
    return allProfiles;
  } catch (error) {
    throw error;
  }
}

export async function getSelectedProfileToken() {
  try {
    const sdk = await getSdk();
    const jwtToken = await sdk.authenticationManager.getSelectedProfileToken();
    return jwtToken;
  } catch (error) {
    throw error;
  }
}

export async function getAllProfiles() {
  try {
    const sdk = await getSdk();
    const allProfiles = await sdk.userManager.getAllProfiles();
    return allProfiles;
  } catch (error) {
    throw error;
  }
}

export async function updateAllProfilesDataInIndexDB(profiles) {
  try {
    const sdk = await getSdk();
    const allProfiles = await sdk.userManager.updateAllProfiles(profiles);
    return allProfiles;
  } catch (error) {
    throw error;
  }
}

export async function updateProfile(profileData) {
  try {
    const sdk = await getSdk();
    const updatedUser = await sdk.userManager.update_v1(profileData);
    return updatedUser;
  } catch (error) {
    console.log("==> ~ updateProfile ~ error:", error);
    throw error;
  }
}

export async function addProfile(profileData) {
  try {
    const sdk = await getSdk();
    const newProfile = await sdk.userManager.addProfile(profileData);
    return newProfile;
  } catch (error) {
    throw error;
  }
}

export async function onEditProfile(data) {
  const { profileId, language } = data;
  const currentProfile = await getCurrentProfile();
  if (data.isMasterProfile) {
    delete data.profileCategory;
  }
  const updatedUser = await updateProfile(data);
  if (language !== this.props.applicationState.userLocale) {
    await getSdk().userManager.setLanguage(language);
  }
  const updatedProfile = updatedUser?.profiles?.find(profile => profile.profileId === profileId);
  await updateAllProfilesDataInIndexDB(updatedUser?.profiles);
  if (currentProfile && currentProfile.profileId === profileId) {
    await updateCurrentProfileInIndexDB(updatedProfile);
  }
  return updatedProfile;
}

export async function onDeleteProfile(data) {
  try {
    const sdk = await getSdk();
    const response = await sdk.userManager.deleteProfile(data);
    return response;
  } catch (error) {
    console.log("==> ~ onDeleteProfile ~ error:", error);
    throw error;
  }
}

export async function updateIndexDBUser(updatedUser) {
  try {
    const sdk = await getSdk();
    await sdk.userManager.updateIndexDBUser(updatedUser);
  } catch (error) {
    throw error;
  }
}

export async function onAddNewProfile(data) {
  const updatedUser = await addProfile(data);
  await updateAllProfilesDataInIndexDB(updatedUser?.profiles);
  await updateIndexDBUser(updatedUser);
  const newProfile = updatedUser?.profiles[updatedUser?.profiles?.length - 1];
  trackEvent("profile_created", null, "MP", newProfile);
  await updateCurrentProfileInIndexDB(newProfile);
  return newProfile;
}

export async function createProfilePin(data) {
  try {
    const sdk = await getSdk();
    const response = await sdk.userManager.addUpdatePin(data);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function verifyProfilePin(data) {
  try {
    const sdk = await getSdk();
    const response = await sdk.userManager.verifyPin(data);
    return response;
  } catch (error) {
    if (error && error.status === 400) {
      return error.message;
    }
    throw error;
  }
}

export async function disableProfilePin(data) {
  try {
    const sdk = await getSdk();
    const response = await sdk.userManager.disablePin(data);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getUpdatedProfile(profileId, country) {
  try {
    const timeStamp = Math.floor(new Date().getTime() / 1000);
    const configuration = await config.request();
    const clientType = configuration.sdk.clientType;
    const signatureParams = {
      "client-type": clientType,
      guid: profileId,
      country,
      timestamp: timeStamp * 1000
    };
    const signature = generateMPSignatureSHA512(signatureParams);
    const data = {
      ...signatureParams,
      hash: signature
    };
    const sdk = await getSdk();
    const response = await sdk.userManager.getProfile(data);
    await updateCurrentProfileInIndexDB(response.data);
    await updateSelectedProfileFromAllProfiles(response.data);
    return response && response.data;
  } catch (error) {
    throw error;
  }
}

export async function verifyPassword(data) {
  try {
    const sdk = await getSdk();
    const response = await sdk.userManager.verifyPassword(data);
    return response;
  } catch (error) {
    // important to return the error due to show error popup as if password is wrong, BE is sending 401
    return error;
  }
}
